export default __webpack_public_path__ + "static/media/iconfinder_badge-html-5_317755.c77fed67.png";